import {
  BankOutlined,
  EnvironmentOutlined,
  InfoCircleOutlined,
  UserOutlined
} from '@ant-design/icons/lib'
import { List } from 'antd'
import KCard from 'app/components/UI-Elements/DataDisplay/KCard'
import IntlStringMessages from 'app/util/IntlStringMessages'
import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'

import KInfoRow from '../../UI-Elements/DataDisplay/KInfoRow'
import AddressSummary from '../Address/AddressSummary'

type Props = {
  showSupplyOwner?: boolean
  showDeliveryContact?: boolean
}

const RentalInfoCard: React.FC<MemberProps<IRental, Props>> = ({
  member: rental,
  props = { showSupplyOwner: true, showDeliveryContact: true }
}) => {
  const intl = useIntl()
  const { showSupplyOwner, showDeliveryContact } = props

  const data = useMemo(() => {
    return [
      showDeliveryContact && {
        value: `${rental.delivery_contact.name || ''} ${rental.delivery_contact.phone || ''}`,
        title: intl.formatMessage({ id: 'rental-show-delivery-contact' }),
        icon: <UserOutlined />
      },
      {
        value: rental.rental_code,
        title: intl.formatMessage({ id: 'rental.request.rental.code' }),
        icon: <InfoCircleOutlined />
      },
      showSupplyOwner &&
        rental.supply_owner && {
          value: `${rental.supply_owner.name || ''} ${rental.supply_owner.phone || ''}`,
          title: intl.formatMessage({ id: 'rental-show-supply-owner' }),
          icon: <BankOutlined />
        },
      {
        value: (
          <AddressSummary
            link={rental.google_maps_direction}
            deliveryAddress={rental.delivery_address}
          />
        ),
        title: intl.formatMessage({ id: 'rental.request.summary.meeting.point' }),
        icon: <EnvironmentOutlined />
      },
      rental.delivery_address.address2 && {
        value: rental.delivery_address.address2,
        title: intl.formatMessage({ id: 'rental.request.summary.meeting.additional.address' }),
        icon: <InfoCircleOutlined />
      }
    ].filter(Boolean)
  }, [rental])

  return (
    <KCard title={<IntlStringMessages id="rental.request.summary.title" />}>
      <List
        itemLayout="horizontal"
        dataSource={data}
        split={false}
        renderItem={(item) => (
          <List.Item>
            <KInfoRow title={item.title} icon={item.icon} info={item.value} />
          </List.Item>
        )}
      />
    </KCard>
  )
}

export default RentalInfoCard
